
<router-outlet></router-outlet>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<doc-toasts aria-live="polite" aria-atomic="true"></doc-toasts>
<p-toast></p-toast>
<doc-global-toast></doc-global-toast>